import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M-524.8 811.8c1 1.2 1.7 2.5 2.2 3.9s.6 2.9.5 4.3-.5 2.8-1.2 4.2-1.6 2.5-2.8 3.6c-1.2 1-2.5 1.7-3.9 2.2-1.4.4-2.9.6-4.3.5-1.4-.1-2.8-.5-4.2-1.2s-2.5-1.6-3.6-2.8c-1-1.2-1.7-2.5-2.2-4-.4-1.4-.6-2.9-.5-4.3s.5-2.8 1.2-4.2 1.6-2.5 2.8-3.6c1.2-1 2.5-1.7 4-2.2 1.4-.4 2.9-.6 4.3-.5 1.4.1 2.8.5 4.2 1.2 1.3.8 2.5 1.7 3.5 2.9zm-13.8 1.2c-.9.7-1.5 1.6-2 2.5s-.7 1.9-.8 2.9 0 2 .3 3 .8 1.9 1.5 2.8 1.5 1.5 2.5 2c.9.5 1.9.7 3 .8 1 .1 2 0 3.1-.3 1-.3 1.9-.8 2.8-1.5.8-.7 1.5-1.5 2-2.5.5-.9.7-1.9.8-3 .1-1 0-2-.3-3.1s-.8-1.9-1.5-2.8c-.7-.8-1.6-1.5-2.5-2s-1.9-.7-2.9-.8-2 0-3 .3c-1.2.5-2.1 1-3 1.7zm-15.6 26.9c-.5.4-1.1.6-1.7.5-.6-.1-1.2-.3-1.6-.8-.4-.5-.6-1.1-.5-1.7s.3-1.2.8-1.6l12.2-10.4 3 3.5-12.2 10.5z",
      stroke: "none"
    }), /*#__PURE__*/jsx("path", {
      className: "map-pin_svg__st0",
      d: "M18.1.4c-7 0-12.7 5.7-12.7 12.7C5.4 25.8 18.1 36 18.1 36s12.7-9.8 12.7-22.9c0-7-5.7-12.7-12.7-12.7zm0 19c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.9 6.4-6.4 6.4z",
      stroke: "none"
    })]
  });
};
const IconMapPin = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "MapPin__IconMapPin",
  componentId: "sc-1m807h7-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconMapPin };
